import { atom } from 'recoil';

export const inviteCodeJoinSuccessState = atom<boolean>({
  key: 'inviteCodeJoinSuccessState',
  default: false,
});
